import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import Steps from './steps';
import ThemeSection from './themesection';
import Preview from './preview';
import { locale } from '../../utils/i18n';
import CodeIntegration from './async/codeintegration';
import Introduction from './introduction';
import Error from './error';
import TransparentButton from './transparent-button';
import common from '../../common/common';
import { onChange } from '../../controller/theme_checkout';
import api from '../../common/api';

class Common extends Component {
  constructor(props) {
    super(props);
  }

  updateLabelValue(key) {
    if (this.props && this.props.onKeyValueChange) {
      common.log('onClick', key);

      api
        .updateCheckoutPreference({ prefName: key, prefValue: 'N' })
        .then(() => {
          //
        })
        .catch(() => {
          //
        });
      this.props.onKeyValueChange(key, true);

      if (key == 'isIntroductionPageVisible') {
        this.props.onKeyValueChange('isGenerateCodeStepEnabled', false);
      }
    }
  }

  render({ isJSCheckoutIntegrated, isGenerateCodeStepEnabled, isIntroductionPageVisible, isError, APP_DATA }) {
    return (
      <section>
        {!isError && !isIntroductionPageVisible && (
          <div class="wrapper">
            <div>
              <h2 class="main-heading heading-trim">{locale('checkout.title')}</h2>
              {(!isIntroductionPageVisible || !isJSCheckoutIntegrated) && (
                <div class={`btn-box`}>
                  {!isJSCheckoutIntegrated && (
                    <TransparentButton
                      codespace={'</>'}
                      name={'Complete JS Integration'}
                      onButtonClick={this.updateLabelValue.bind(this, 'isJSCheckoutIntegrated')}
                    />
                  )}
                  {!isIntroductionPageVisible && (
                    <TransparentButton
                      image={`${common.getStaticPath()}/assets/images/ic-lightbulb-outline.svg`}
                      name={`Need help? Take a tour`}
                      onButtonClick={this.updateLabelValue.bind(this, 'isIntroductionPageVisible')}
                    />
                  )}
                </div>
              )}
            </div>

            {isJSCheckoutIntegrated && <Steps />}
            {!isGenerateCodeStepEnabled && (
              <div class="theme-content">
                <ThemeSection />
                <Preview />
              </div>
            )}
            {isGenerateCodeStepEnabled && <CodeIntegration />}
          </div>
        )}
        {isError && <Error appData={APP_DATA} />}
        {!isError && isIntroductionPageVisible && <Introduction />}
      </section>
    );
  }
}

export default connect(
  'isGenerateCodeStepEnabled, isIntroductionPageVisible, isError, isJSCheckoutIntegrated',
  onChange
)(Common);



// WEBPACK FOOTER //
// ./checkout/components/common.js